<template>
  <div class="level-item has-text-centered">
    <div>
      <p class="heading">Submitted Writeups</p>
      <p class="title">{{ writeups }}</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      writeups: 0,
    };
  },
  async mounted() {
    try {
      const data = await this.$ctforge.api.get('/admin/writeup/list');
      this.writeups = Object.values(data).reduce(
        (acc, c) => acc + (c.submissions ? c.submissions.length : 0), 0,
      );
    } catch (e) {
      // stats are non-critical
    }
  },
};
</script>
